import script from "./dashboard-dynamic-view.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard-dynamic-view.vue?vue&type=script&setup=true&lang=js"

import "./dashboard-dynamic-view.vue?vue&type=style&index=0&id=df8beddc&scoped=true&lang=scss"
import "./dashboard-dynamic-view.vue?vue&type=style&index=1&id=df8beddc&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df8beddc"]])

export default __exports__